export class PaymentHelpers {
  static getExpirationMonthAndYear = (expirationDate: string) => {
    const [expMonth, expYear] = expirationDate?.split('/') || ['', ''];
    const formattedExpMonth = expMonth.length === 1 ? `0${expMonth}` : expMonth;
    const currentDate = new Date();
    const formattedExpYear =
      expYear.length === 2 ? `${currentDate?.getFullYear()?.toString()?.slice(0, 2)}${expYear}` : expYear;
    return { expMonth: formattedExpMonth, expYear: formattedExpYear };
  };
}
